import Api from '@/common/fetch.js'
import { parkingApiRoute } from '@/common/config'

export default {
    getParkings(request) {
        return Api.get(parkingApiRoute + 'api/Parkings/', request)
    }
}
